import { render } from "./active-details.vue?vue&type=template&id=1bdd8cb2&scoped=true"
import script from "./active-details.vue?vue&type=script&lang=js"
export * from "./active-details.vue?vue&type=script&lang=js"

import "./active-details.vue?vue&type=style&index=0&id=1bdd8cb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdd8cb2"]])

export default __exports__